export default function MessageGenerateToHtml({
    message
}) {
    return <p
        className="chat-message"
        style={{ whiteSpace: "pre-line", paddingLeft: '16px', paddingRight: '16px' }}
        dangerouslySetInnerHTML={{ __html: message }}
    ></p>
}